<app-banner [title]="'Autorisations'" [links]="links"></app-banner>

<div class="container mx-auto px-4 py-6">

	<!-- View Switcher -->
	<div class="mb-6 border-b border-gray-200">
		<nav class="-mb-px flex space-x-8">
			<button (click)="switchView('given')"
				[class]="viewMode === 'given' 
				? 'border-primary text-primary whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm' 
				: 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'">
				Demandes & Accès gérés
			</button>
			<button (click)="switchView('received')"
				[class]="viewMode === 'received' 
				? 'border-primary text-primary whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm' 
				: 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'">
				Mes autorisations
			</button>
		</nav>
	</div>

	<div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-4">
		<!-- Recherche (Gauche) -->
		<div class="flex items-center gap-x-2">
			<label for="search" class="text-[12px]">Rechercher : </label>
			<input type="text" id="search" [(ngModel)]="searchTerm" (input)="onSearchChange()"
				class="placeholder:text-gray-300 text-[12px] rounded-lg border border-gray-300 w-[300px] p-2"
				placeholder="Rechercher une autorisation..." />
		</div>

		<!-- Filtres et Actions (Droite) -->
		<div class="flex items-center gap-x-1 ml-auto">
			<!-- Filtres par status (uniquement pour les autorisations données) -->
			<div *ngIf="viewMode === 'given'" class="flex items-center gap-x-2">
				<label for="statusFilter" class="text-[12px]">Filtrer :</label>
				<select id="statusFilter" [(ngModel)]="selectedStatus" (change)="onStatusChange()"
					class="text-[12px] rounded-lg border border-gray-200 px-3 py-1.5 focus:ring-1 focus:ring-primary outline-none">
					<option *ngFor="let option of statusOptions" [value]="option.value">
						{{ option.label }}
					</option>
				</select>
			</div>

			<!-- Bouton Refresh (Icone uniquement) -->
			<button (click)="refreshData()" [disabled]="loading"
				class="p-2 transition-all duration-200 text-gray-400 hover:text-primary scale-80 disabled:opacity-50 group flex items-center justify-center"
				title="Actualiser">
				<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 transition-colors group-hover:text-primary"
					[class.animate-spin]="loading" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
						d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
				</svg>
			</button>
		</div>
	</div>

	<!-- Loading state -->
	<div *ngIf="loading" class="text-center py-12">
		<div class="max-w-md mx-auto">
			<div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
			<h3 class="mt-4 text-sm font-medium text-gray-900">Chargement...</h3>
		</div>
	</div>

	<!-- Error state -->
	<div *ngIf="error && !loading" class="text-center py-12">
		<div class="max-w-md mx-auto">
			<svg class="mx-auto h-12 w-12 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
					d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
			</svg>
			<h3 class="mt-2 text-sm font-medium text-gray-900">Erreur</h3>
			<p class="mt-1 text-sm text-gray-500">{{ error }}</p>
			<button (click)="refreshData()" class="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
				Réessayer
			</button>
		</div>
	</div>

	<!-- Tableau des autorisations -->
	<div *ngIf="!loading && !error" class="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow">
		<table class="w-full">
			<thead>
				<tr class="bg-gray-100 border-b border-gray-200">
					<th class="text-left py-3 px-4 text-[14px] font-semibold text-gray-900">
						{{ viewMode === 'given' ? 'Autorisé(e)' : 'Compte autoriseur' }}
					</th>
					<th class="text-left py-3 px-4 text-[14px] font-semibold text-gray-900">{{ viewMode === 'given' ?
						'Motif' : 'Description' }}</th>
					<th class="text-left py-3 px-4 text-[14px] font-semibold text-gray-900">Permissions</th>
					<th class="text-left py-3 px-4 text-[14px] font-semibold text-gray-900">Date d'activation</th>
					<th class="text-left py-3 px-4 text-[14px] font-semibold text-gray-900">Date d'expiration</th>
					<th *ngIf="viewMode === 'given'"
						class="text-left py-3 px-4 text-[14px] font-semibold text-gray-900">Actions</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let auth of filteredAuthorizations" class="hover:bg-gray-50 border-b border-gray-100">
					<td class="py-3 px-4 text-[12px] text-gray-900 font-medium">
						{{ viewMode === 'given' ? auth.granteeName : auth.granterName }}
					</td>
					<td class="py-3 px-4 text-[12px] text-gray-900">
						{{ auth.meta.label }}
					</td>
					<td class="py-3 px-4 text-[12px] text-gray-900">
						<ul class="space-y-1">
							<li *ngFor="let permission of getFormattedPermissionsList(auth.permissions)"
								class="text-[12px] text-gray-900">
								• {{ permission }}
							</li>
						</ul>
					</td>
					<td class="py-3 px-4 text-[12px] text-gray-900">
						{{ auth.status !== 'pending' && auth.activatedAt ? formatDate(auth.activatedAt) : '-' }}
					</td>
					<td class="py-3 px-4 text-[12px] text-gray-900">
						{{ auth.expiresAt ? formatDate(auth.expiresAt) : '-' }}
					</td>
					<td *ngIf="viewMode === 'given'" class="py-3 px-4">
						<div class="flex items-center gap-2">
							<button *ngIf="canValidateAuthorization(auth)" (click)="validateAuthorization(auth)"
								[disabled]="loading"
								class="px-2 py-1 text-[10px] font-medium text-white bg-green-600 hover:bg-green-700 rounded disabled:opacity-50">
								Valider
							</button>
							<button *ngIf="auth.status === 'active' && auth.revocable"
								(click)="revokeAuthorization(auth)" [disabled]="loading"
								class="px-2 py-1 text-[10px] font-medium text-white bg-red-600 hover:bg-red-700 rounded disabled:opacity-50">
								Révoquer
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<!-- Empty state -->
		<div *ngIf="filteredAuthorizations.length === 0" class="text-center py-12 bg-white">
			<svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
					d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
			</svg>
			<h3 class="mt-2 text-sm font-medium text-gray-900">Aucune autorisation</h3>
			<p class="mt-1 text-sm text-gray-500">
				Aucune autorisation trouvée pour les critères sélectionnés.
			</p>
		</div>
	</div>

	<!-- Pagination -->
	<div *ngIf="!loading && !error && totalItems > 0"
		class="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6">
		<div class="text-sm text-gray-600">
			Affichage de {{ (currentPage - 1) * itemsPerPage + 1 }} à {{ Math.min(currentPage * itemsPerPage,
			totalItems) }}
			sur {{ totalItems }} résultats
		</div>

		<div class="flex items-center space-x-1">
			<button
				class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-l-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
				[disabled]="currentPage === 1 || loading" (click)="changePage(currentPage - 1)">
				<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
					stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
				</svg>
			</button>

			<button *ngFor="let page of pages"
				class="px-3 h-8 text-sm font-medium border border-gray-300 hover:bg-gray-50"
				[class]="page === currentPage ? 'bg-primary text-white ' : 'bg-white text-gray-700'"
				[disabled]="loading" (click)="changePage(page)">
				{{ page }}
			</button>

			<button
				class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-r-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
				[disabled]="currentPage === totalPages || loading" (click)="changePage(currentPage + 1)">
				<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
					stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
				</svg>
			</button>
		</div>
	</div>
</div>